export const state = {
  formaPagamento: {},
  formasPagamento: [],
  modalExcluirFormaPagamento: false,
  recorrenciasFormaPagamento: [
    {
      dias: 30,
      descricao: "MENSAL",
    },
    {
      dias: 15,
      descricao: "QUINZENAL",
    },
    {
      dias: 7,
      descricao: "SEMANAL",
    },
    {
      dias: 1,
      descricao: "DIÁRIA",
    },
  ],
  formasPagamentoNfe: [
    {
      codigo: "01",
      descricao: "Dinheiro",
    },
    {
      codigo: "02",
      descricao: "Cheque",
    },
    {
      codigo: "03",
      descricao: "Cartão de Crédito",
    },
    {
      codigo: "04",
      descricao: "Cartão de Débito",
    },
    {
      codigo: "05",
      descricao: "Crédito Loja",
    },
    {
      codigo: "10",
      descricao: "Vale Alimentação",
    },
    {
      codigo: "15",
      descricao: "Boleto Bancário",
    },
    {
      codigo: "16",
      descricao: "Depósito Bancário",
    },
    {
      codigo: "17",
      descricao: "Pagamento Instantâneo (PIX)",
    },
    {
      codigo: "18",
      descricao: "Transferência Bancária, Carteira Digital",
    },
    {
      codigo: "19",
      descricao: "Cronograma de fidelidade, Cashback, Crédito Virtual",
    },
    {
      codigo: "99",
      descricao: "Outros",
    },
  ],
};

export default {};
